import {applyPatch, createPatch, type Operation} from 'rfc6902';
import cloneDeep from 'lodash/cloneDeep.js';
import {MissingError, TestError, InvalidOperationError} from 'rfc6902/patch';

export function tryParseJson(input: string): unknown {
  try {
    return JSON.parse(input);
  } catch (err) {
    return undefined;
  }
}

declare const __brand: unique symbol;
type Brand<B> = {[__brand]: B};
export type Branded<T, B> = T & Brand<B>;

export type JsonPatch<T> = Branded<T, 'JsonPatch'>;

export function buildJsonPatch<T>(prevObject: T, nextObject: T): JsonPatch<T> {
  return createPatch(prevObject, nextObject) as JsonPatch<T>;
}

export function applyJsonPatch<T>(prevObject: T, patch: JsonPatch<T>): T {
  const newObject = cloneDeep(prevObject);
  const operationErrors = applyPatch(newObject, patch as Operation[]);

  // applyPatch returns an array of errors associated w/ each operation
  //  null if no error
  const firstError = operationErrors.find(
    (error: MissingError | TestError | InvalidOperationError | null) => error !== null
  );

  if (firstError) {
    throw firstError;
  }

  return newObject;
}
